<script>
  import {firebaseUser} from "./auth/authStore";
  import Auth from "./auth/Auth.svelte";
  import Loading from "./general/Loading.svelte";
  import {Router, Link, Route} from "svelte-routing";
  import Main from "./Main.svelte";
  import MessagePage from "./messages/MessagePage.svelte";
  import {snackbars} from './snackbar/snackbarStore';
  import Snackbar from "./snackbar/Snackbar.svelte";

</script>

<main>
    {#if $firebaseUser === undefined}
      <Loading fullscreen/>
    {:else if !$firebaseUser}
      <Auth/>
    {:else}
    <!--    TODO: should I use router?-->
      <Main/>
    {/if}

</main>

{#each $snackbars as snackbar (snackbar.id)}
  <Snackbar visible {...snackbar.props}/>
{/each}

<style>
  main {
    width: 100%;
    height: 100%;
  }

</style>